import styled from "styled-components";

export const WelcomeBodyText = styled.div`
    padding: 1rem;
    text-align: justify;
    font-size: 1.12rem;
    line-height: 1.3;
`;

export const WelcomeUser = styled.div`
    padding: 2rem 1rem 0rem 1rem;
`;

export const OverviewPageWrapper = styled.div`
    background-color: ${({ theme }) => theme.palette.common.white};
    border-radius: 4px;
`;
